module.exports = __webpack_public_path__ + "img/av074.40dc2dc5.png";